import { GetTrainingsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const editPolicyKey = 'trainings.training.can_edit'

interface Props {
  ids?: number[]
  catalog?: boolean
}

export const useTrainings = ({ ids, catalog }: Props) => {
  const { loading, data, error } = useQuery(GetTrainingsDocument, { variables: { ids, catalog } })

  return {
    error,
    loading,
    trainings: data ? data.trainings.trainingsConnection.nodes : undefined, // Provide a default value
  }
}
